export default __webpack_public_path__ + "static/media/snacks.915b19cb.png";